var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiguremixedcardio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 21.9921 26.918",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 26.918,
    opacity: 0,
    width: 21.9921,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8203 15.75L13.6445 20.1797L15.7539 25.9922C15.9882 26.6367 16.6093 26.8477 17.1367 26.6484C17.6992 26.4609 17.9921 25.8164 17.7812 25.2656L15.6484 19.3945L13.5273 13.5703L13.5273 8.28516C13.5273 8.03906 13.6562 7.81641 13.8789 7.69922L21.0625 3.86719C21.5898 3.58594 21.789 2.94141 21.5078 2.40234C21.2265 1.875 20.582 1.6875 20.0546 1.96875L13.1171 5.63672C12.3437 6.04688 11.582 6.23438 10.8203 6.23438C10.0586 6.23438 9.29684 6.04688 8.5234 5.63672L1.5859 1.96875C1.05856 1.6875 0.414024 1.875 0.132774 2.40234C-0.160195 2.94141 0.0507428 3.58594 0.578087 3.86719L7.76168 7.69922C7.98434 7.81641 8.11324 8.03906 8.11324 8.28516L8.11324 13.5703L5.99215 19.3945L3.85934 25.2656C3.6484 25.8164 3.94137 26.4609 4.49215 26.6484C5.03121 26.8477 5.65231 26.6367 5.88668 25.9922L7.99606 20.1797ZM10.8203 5.01562C12.1914 5.01562 13.3046 3.89062 13.3046 2.49609C13.3046 1.125 12.1914 0 10.8203 0C9.42574 0 8.30074 1.125 8.30074 2.49609C8.30074 3.89062 9.42574 5.01562 10.8203 5.01562Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiguremixedcardio);
export default __webpack_public_path__ + "static/media/figure.mixed.cardio.fc94d2c042e1bda14c02124120b7a5d4.svg";
export { ForwardRef as ReactComponent };